import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class Login5 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errorMessage: '',
      successMessage: '',
    };
  }

  // Handle input changes for email and password fields
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  // Handle form submission (Login)
  handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = this.state;

    // Check if email and password are provided
    if (!(email && password)) {
      this.setState({ errorMessage: 'Email and Password are required!' });
      return;
    }

    try {
      // Sending login request to the backend
      const response = await fetch('/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.toLowerCase(), password }),
      });

      const data = await response.json();

      if (response.status === 200) {
        // Successfully logged in, setting success message
        this.setState({
          successMessage: 'Login successful!',
          errorMessage: '',
        });

        // Redirect to OCR page and pass user data (email, balance)
        this.props.history.push({
          pathname: '/thaiocr',
          state: { email: data.email, balance: data.balance },
        });
      } else {
        // If login fails, set the error message
        this.setState({
          errorMessage: data.message || 'Invalid Credentials!',
          successMessage: '',
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ errorMessage: 'An error occurred!', successMessage: '' });
    }
  };

  render() {
    const { errorMessage, successMessage } = this.state;

    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className="logo" src={logo} alt="Logo" />
          <br />
          <div>
            <Link to="/">Home</Link>
          </div>
          <br />
          <div>Please login to hash your document...</div>
          <br />
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        id="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>

                    {errorMessage && (
                      <div className="alert alert-danger">{errorMessage}</div>
                    )}
                    {successMessage && (
                      <div className="alert alert-success">{successMessage}</div>
                    )}

                    <button type="submit" className="btn btn-dark w-100">
                      Login
                    </button>

                    {/* 🔹 Forgot Password link */}
                    <div style={{ marginTop: '10px' }}>
                      <Link
                        to="/forgetpassword"
                        style={{
                          color: '#007bff',
                          textDecoration: 'none',
                          fontSize: '0.9rem',
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.textDecoration = 'underline')
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.textDecoration = 'none')
                        }
                      >
                        Forgot password?
                      </Link>
                    </div>
                  </form>

                  <div style={{ marginTop: '20px' }}>Powered by</div>
                  <img className="logo2" src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login5);
